/* global axios */
import ApiClient from './ApiClient';

// Fala só com o Rails do Fluxi: a chave do helpdesk nunca chega ao navegador.
class SuporteAmshiftAPI extends ApiClient {
  constructor() {
    super('suporte_amshift', { accountScoped: true });
  }

  catalogo() {
    return axios.get(`${this.url}/catalogo`);
  }

  listarChamados({ todos = false } = {}) {
    return axios.get(`${this.url}/chamados`, {
      params: todos ? { todos: 1 } : {},
    });
  }

  abrirChamado(formData) {
    return axios.post(`${this.url}/chamados`, formData);
  }

  detalharChamado(numero) {
    return axios.get(`${this.url}/chamados/${numero}`);
  }

  responderChamado(numero, formData) {
    return axios.post(`${this.url}/chamados/${numero}/interacoes`, formData);
  }

  // Link de uso único (30 min): pedir no clique, nunca guardar.
  abrirSessao() {
    return axios.post(`${this.url}/sessao`);
  }
}

export default new SuporteAmshiftAPI();
